import type { ContextMenuPlacement } from "../types/contextMenu.types";

type GetSafeMenuPositionParams = {
    position: ContextMenuPlacement;
    menuWidth?: number;
    menuHeight?: number;
    offset?: number;
};

export function getSafeMenuPosition({
    position,
    menuWidth = 240,
    menuHeight = 320,
    offset = 8,
}: GetSafeMenuPositionParams): ContextMenuPlacement {
    if (typeof window === "undefined") {
        return position;
    }

    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    let x = position.x;
    let y = position.y;

    if (x + menuWidth + offset > viewportWidth) {
        x = Math.max(offset, viewportWidth - menuWidth - offset);
    }

    if (y + menuHeight + offset > viewportHeight) {
        y = Math.max(offset, viewportHeight - menuHeight - offset);
    }

    return { x, y };
}

type GetSubmenuDirectionParams = {
    parentRect: DOMRect;
    submenuWidth?: number;
    offset?: number;
};

export function getSubmenuDirection({
    parentRect,
    submenuWidth = 240,
    offset = 8,
}: GetSubmenuDirectionParams): "right" | "left" {
    if (typeof window === "undefined") {
        return "right";
    }

    const hasRightSpace = parentRect.right + submenuWidth + offset <= window.innerWidth;

    return hasRightSpace ? "right" : "left";
}